export default {
  computed: {
    schemaStatusPelaporan() {
      return [
        {
          type: 'VRadio',
          name: 'is_terlaksana',
          label: 'Apakah Anda melakukan monev?',
          labelColor: 'indigo',
          hint: 'wajib diisi',
          required: true,
          items: [
            { text: 'Ya', value: 1 },
            { text: 'Tidak', value: 0 },
          ],
          grid: { cols: 12, md: 6 },
        },
        {
          disabled: this.readOnly,
          show: { status: +this.form.is_terlaksana === 0 },
          required: +this.form.is_terlaksana === 0,
          type: 'VTextarea',
          name: 'alasan_lain',
          label: 'Alasan tidak menyelenggarakan kegiatan',
          labelColor: 'indigo',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
          rows: 2,
          autoGrow: true,
        },
      ];
    },

    schemaPendampingan2024() {
      const termins = { 1: 'Termin 1 (Agustus sampai Oktober 2024)', 7: 'Termin 2 (Februari sampai April 2025)' };
      const kegiatan = this.$getDeepObj(this.info, `kegiatan`) || {};
      const fasilitators = this.$getDeepObj(this.info, 'fasilitators') || [];

      return {
        dasar: {
          title: 'Gambaran Umum Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Termin Monev',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: termins[kegiatan.pendampingan_ke] || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Jenis Sekolah',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: kegiatan.jenis || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Jumlah FSP Binaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value:
                this.$getDeepObj(this.info, 'laporan.jml_pa_binaan') ||
                (this.$getDeepObj(this.info, 'meta.pa') || []).length ||
                '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              type: 'VSelect',
              name: 'k_koordinator_tema_psp',
              label: 'Tema Penguatan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: (this.info.opsis['tema'] || []).map((opsi) => {
                return {
                  text: opsi.keterangan,
                  value: opsi.k_koordinator_opsi_psp,
                };
              }),
              outlined: true,
              singleLine: true,
              hideDetails: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda Pelaksanaan Monev',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              hideDetails: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: !this.isPreview },
              type: 'VSelect',
              name: 'psp_profil_id_pa',
              label: 'Nama FSP',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: fasilitators.map((fsp) => {
                return {
                  text: this.$getDeepObj(fsp, 'ptk.nama'),
                  value: fsp.psp_profil_id,
                };
              }),
              outlined: true,
              singleLine: true,
              hideDetails: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: this.isPreview },
              type: 'textView',
              name: 'psp_profil_id_pa',
              label: 'Nama FSP',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.info, 'laporan.psp_profil_pa.ptk.nama') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: !this.isPreview },
              type: 'VSelect',
              name: 'sekolah_id',
              label: 'Nama Sekolah Sasaran',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.sekolahBinaanFsp.map((sekolah) => {
                return {
                  text: sekolah.nama,
                  value: sekolah.sekolah_id,
                  sekolah: sekolah,
                };
              }),
              slot: ['selection', 'item'],
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: this.isPreview },
              type: 'textView',
              name: 'sekolah_id',
              label: 'Nama Sekolah Sasaran',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              class: 'mb-4',
              value: this.$getDeepObj(this.info, 'laporan.sekolah.nama') || '',
              grid: { cols: 12, md: 6 },
            },
          ],
        },
        observasi: {
          title: 'Kegiatan Observasi',
          laporan: this.listInstrumen['ds24-observasi'],
        },
        kendalaAV: {
          hidden: !this.instrumens['ds24-kendala-av'],
          title: 'Kegiatan Wawancara Sekolah Kendala A sampai V',
          laporan: this.listInstrumen['ds24-kendala-av'],
        },
        kendalaWZ: {
          hidden: !this.instrumens['ds24-kendala-wz'],
          title: 'Kegiatan Wawancara Sekolah Kendala W sampai Z',
          laporan: this.listInstrumen['ds24-kendala-wz'],
        },
        praktik: {
          hidden: !this.instrumens['ds24-praktik'],
          title: 'Kegiatan Wawancara Sekolah Praktik Baik',
          laporan: this.listInstrumen['ds24-praktik'],
        },
      };
    },
  },
};
